import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { sizes } from 'utils/detection';
import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Title from './styled/Title';
import Paragraph1 from './styled/Paragraph1';
import Paragraph2 from './styled/Paragraph2';
import Img from './styled/Img';
import Header from './styled/Header';
import Article from './styled/Article';
import TextWrapper from './styled/TextWrapper';

export default class CompanySection extends PureComponent {
  static defaultProps = {};

  static contextType = ThemeContext;

  state = {
    isMedium: false,
  };

  componentDidMount() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.setState({ isMedium: window.innerWidth >= sizes.medium });
  };

  render() {
    const { className, heading, title, paragraph1, paragraph2, childRef } =
      this.props;
    const { isMedium } = this.state;

    const imgSrc = `/images/about/company/about-company${
      isMedium ? '-medium' : ''
    }.jpg`;

    return (
      <Wrapper ref={childRef}  className={className}>
        <TextWrapper>
          <Header>
            <Heading theme={this.context}>{heading}</Heading>
            <Title theme={this.context}>{title}</Title>
          </Header>
          <Article>
            <Paragraph1
              theme={this.context}
              dangerouslySetInnerHTML={{ __html: paragraph1 }}
            />
            <Paragraph2 theme={this.context}>{paragraph2}</Paragraph2>
          </Article>
        </TextWrapper>
        <Img src={imgSrc} />
      </Wrapper>
    );
  }
}
